import { motion } from "framer-motion";

export const Card = ({ children }) => {
  return (
    <motion.div
      whileHover={{ y: -4 }}
      className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm hover:shadow-md transition"
    >
      {children}
    </motion.div>
  );
};

export const CardContent = ({ className = "", children }) => (
  <div className={"p-6 " + className}>{children}</div>
);
